import { useCallback } from 'react';

import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { ShareChannel } from '../../types';
import { useGetHeadlineVariant } from '../bandits';

import { useGenPetitionUrl } from './genUrl';
import { useGetPetitionShareUrlSuffix } from './pathSuffix';

const MEDIUM_MAPPING: Partial<Record<ShareChannel, string>> = {
	facebookMessenger: 'facebook',
	copy: 'copylink',
};

export function useGetShareUrl(): ShareActionsOptions<ShareChannel>['getUrl'] {
	const genUrl = useGenPetitionUrl();
	const getVariant = useGetHeadlineVariant();

	const getDefaultPathSuffix = useGetPetitionShareUrlSuffix();

	return useCallback(
		// eslint-disable-next-line complexity
		(channel) => {
			const medium = MEDIUM_MAPPING[channel] || channel;
			const pathSuffix = getDefaultPathSuffix(channel);

			switch (channel) {
				case 'facebook':
				case 'whatsapp':
				case 'copy':
				case 'twitter': {
					const variant = getVariant(channel);
					if (variant) {
						return genUrl({
							medium,
							pathSuffix: variant.pathSuffix,
							additionalParams: variant.urlParameters,
						});
					}
					return genUrl({ medium, pathSuffix });
				}
				default:
					return genUrl({ medium, pathSuffix });
			}
		},
		[genUrl, getDefaultPathSuffix, getVariant],
	);
}
